/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { State } from '../redux';

// We actually return an annotated, typed version of use selector here
export const useRootSelector: TypedUseSelectorHook<State> = useSelector;
